// Romanian locale overrides for the Syncfusion document editor (ribbon + dialogs/menus/properties pane).
// Strings absent here fall back to the upstream English locale.
export const RO_EDITOR_LOCALE = {
  "documenteditorcontainer": {
    "New": "Nou",
    "Open": "Deschide",
    "Undo": "Anulare",
    "Redo": "Refacere",
    "Image": "Imagine",
    "Table": "Tabel",
    "Link": "Legătură",
    "Bookmark": "Marcaj",
    "Table of Contents": "Cuprins",
    "HEADING - - - - 1": "CAPITOLUL - - - - 1",
    "HEADING - - - - 2": "CAPITOLUL - - - - 2",
    "HEADING - - - - 3": "CAPITOLUL - - - - 3",
    "Header": "Antet",
    "Footer": "Subsol",
    "Page Setup": "Configurare pagină",
    "Page Number": "Număr de pagină",
    "Break": "Întrerupere",
    "Find": "Găsire",
    "Local Clipboard": "Clipboard local",
    "Restrict Editing": "Restricționare editare",
    "Content Control": "Controlul conținutului",
    "Rich Text Content Control": "Control bogat de conținut text",
    "Plain Text Content Control": "Controlul conținutului de text simplu",
    "Picture Content Control": "Controlul conținutului de imagine",
    "Combo Box Content Control": "Controlul conținutului de casetă combo",
    "Drop-Down List Content Control": "Controlul conținutului listei derulante",
    "Date Picker Content Control": "Control de conținut selector de dată",
    "Check Box Content Control": "Control de conținut casetă de selectare",
    "Upload from computer": "Încărcați de pe computer",
    "By URL": "Pe adresa URL",
    "Page Break": "Întrerupere de pagină",
    "Section Break": "Întrerupere de secțiune",
    "Header And Footer": "Antet și subsol",
    "Options": "Opțiuni",
    "Levels": "Niveluri",
    "Different First Page": "Prima pagină diferită",
    "Different header and footer for odd and even pages": "Antet și subsol diferit pentru pagini impare și par.",
    "Different Odd And Even Pages": "Pagini diferite impar și par",
    "Different header and footer for first page": "Antet și subsol diferit pentru prima pagină.",
    "Position": "Poziție",
    "Header from Top": "Antet de sus",
    "Footer from Bottom": "Subsol de jos",
    "Distance from top of the page to top of the header": "Distanța de la partea de sus a paginii până la partea de sus a antetului.",
    "Distance from bottom of the page to bottom of the footer": "Distanța de la partea de jos a paginii până la partea de jos a subsolului.",
    "Aspect ratio": "Raportul de aspect",
    "W": "W",
    "H": "H",
    "Width": "Lățime",
    "Height": "Înălțime",
    "Text": "Text",
    "Paragraph": "Paragraf",
    "Fill": "Umplere",
    "Fill color": "Culoare de umplere",
    "Border Style": "Stil chenar",
    "Outside borders": "Chenare exterioare",
    "All borders": "Toate chenarele",
    "Inside borders": "Chenare interioare",
    "Left border": "Chenar stânga",
    "Inside vertical border": "Chenar interior vertical",
    "Right border": "Chenar dreapta",
    "Top border": "Chenar sus",
    "Inside horizontal border": "Chenar interior orizontal",
    "Bottom border": "Chenar jos",
    "Border color": "Culoare chenar",
    "Border width": "Lățime chenar",
    "Cell": "Celulă",
    "Merge cells": "Îmbinare celule",
    "Insert Or Delete": "Inserare sau ștergere",
    "Insert columns to the left": "Inserare coloane la stânga",
    "Insert columns to the right": "Inserare coloane la dreapta",
    "Insert rows above": "Inserare rânduri deasupra",
    "Insert rows below": "Inserare rânduri dedesubt",
    "Delete rows": "Ștergere rânduri",
    "Delete columns": "Ștergere coloane",
    "Cell Margin": "Margine celulă",
    "Top": "Sus",
    "Bottom": "Jos",
    "Left": "Stânga",
    "Right": "Dreapta",
    "Align Text": "Aliniere text",
    "Align top": "Aliniere sus",
    "Align bottom": "Aliniere jos",
    "Align center": "Aliniere la centru",
    "Number of heading or outline levels to be shown in table of contents": "Numărul de niveluri de titlu sau contur care trebuie afișate în conținut.",
    "Show page numbers": "Afișează numerele paginii",
    "Show page numbers in table of contents": "Afișează numerele de pagină în cuprins.",
    "Right align page numbers": "Aliniază la dreapta numerele de pagină",
    "Right align page numbers in table of contents": "Aliniază la dreapta numerele de pagină în cuprins.",
    "Use hyperlinks": "Folosiți hyperlink-uri",
    "Use hyperlinks instead of page numbers": "Folosiți hyperlink-uri în loc de numere de pagină.",
    "Font": "Font",
    "Font Size": "Dimensiune font",
    "Font color": "Culoarea fontului",
    "Text highlight color": "Culoarea evidențiată a textului",
    "Clear all formatting": "Golire formatare",
    "Bold Tooltip": "Bold (Ctrl + B)",
    "Italic Tooltip": "Italic (Ctrl + I)",
    "Underline Tooltip": "Subliniere (Ctrl + U)",
    "Strikethrough": "Barat",
    "Superscript Tooltip": "Exponent (Ctrl + Shift ++)",
    "Subscript Tooltip": "Indice (Ctrl + =)",
    "Align left Tooltip": "Aliniați la stânga (Ctrl + L)",
    "Center Tooltip": "Centru (Ctrl + E)",
    "Align right Tooltip": "Aliniați dreapta (Ctrl + R)",
    "Justify Tooltip": "Justificați (Ctrl + J)",
    "Decrease indent": "Micșorare indent",
    "Increase indent": "Mărire indent",
    "Line spacing": "Spațiere între rânduri",
    "Bullets": "Marcatori",
    "Numbering": "Numerotare",
    "Styles": "Stiluri",
    "Manage Styles": "Gestionare stiluri",
    "Page": "Pagină",
    "of": "de",
    "Fit one page": "Potrivire la o pagină",
    "Spell Check": "Verificare ortografică",
    "Spelling": "Ortografie",
    "Underline errors": "Subliniază erorile",
    "Fit page width": "Potrivire la lățimea paginii",
    "Update": "Actualizare",
    "Cancel": "Anulare",
    "Insert": "Inserare",
    "No Border": "Fără chenar",
    "Create a new document": "Creați un document nou.",
    "Open a document": "Deschideți un document.",
    "Undo Tooltip": "Anulați ultima operație (Ctrl + Z).",
    "Redo Tooltip": "Refaceți ultima operație (Ctrl + Y).",
    "Insert inline picture from a file": "Inserați o imagine în linie dintr-un fișier.",
    "Insert a table into the document": "Inserați un tabel în document.",
    "Create Hyperlink": "Creați un link în documentul dvs. pentru acces rapid la paginile și fișierele web (Ctrl + K).",
    "Insert a bookmark in a specific place in this document": "Introduceți un marcaj într-un loc specific în acest document.",
    "Provide an overview of your document by adding a table of contents": "Oferiți o imagine de ansamblu a documentului dvs. adăugând un cuprins.",
    "Add or edit the header": "Adăugați sau editați antetul.",
    "Add or edit the footer": "Adăugați sau editați subsolul.",
    "Open the page setup dialog": "Deschideți dialogul de configurare a paginii.",
    "Add page numbers": "Adăugați numere de pagină.",
    "Find Text": "Găsiți text în document (Ctrl + F).",
    "Toggle between the internal clipboard and system clipboard": "Comutați între clipboardul intern și panoul de sistem. </br> Accesul la panoul de bord al sistemului prin script este refuzat din cauza politicii de securitate a browserelor. În schimb, </br> 1. Puteți permite clipboard-ului intern să taie, să copieze și să lipească în componentă. </br> 2. Puteți utiliza comenzile rapide de la tastatură (Ctrl + X, Ctrl + C și Ctrl + V) pentru a tăia , copiați și lipiți cu clipboardul sistemului.",
    "Current Page Number": "Numărul de pagină curent din document. Faceți clic sau atingeți pentru a naviga pe o anumită pagină.",
    "Read only": "Doar citire",
    "Protections": "Protecții",
    "Error in establishing connection with web server": "Eroare la stabilirea conexiunii cu serverul web",
    "Single": "Simplu",
    "Double": "Dublu",
    "New comment": "Comentariu nou",
    "Comments": "Comentarii",
    "Print layout": "Aspect imprimat",
    "Web layout": "Aspect web",
    "Text Form": "Formular de text",
    "Check Box": "Caseta de bifat",
    "DropDown": "Listă derulantă",
    "Update Fields": "Câmpuri de actualizare",
    "Update cross reference fields": "Actualizați câmpurile de referință încrucișate",
    "Hide properties pane": "Ascundeți panoul de proprietăți",
    "Show properties pane": "Afișați panoul de proprietăți",
    "Form Fields": "Câmpuri formular",
    "Track Changes": "Țineți evidența modificărilor făcute în document",
    "TrackChanges": "Urmărește modificările",
    "AllCaps": "Majuscule",
    "Change case Tooltip": "Modificare după caz",
    "Insert Footnote": "Inserare notă de subsol",
    "Insert Endnote": "Inserare notă de final",
    "Footnote Tooltip": "Inserați o notă de subsol (Alt + Ctrl + F).",
    "Endnote Tooltip": "Inserați o notă de final (Alt + Ctrl + D).",
    "UPPERCASE": "MAJUSCULE",
    "Lowercase": "Minuscule",
    "SentenceCase": "Tip propoziție",
    "FirstCapital": "Prima majusculă",
    "CapitalizeEachWord": "Fiecare Cuvânt Cu Majuscule",
    "ToggleCase": "Comutare MAJUSCULE/minuscule",
    "No color": "Fără culoare",
    "Top margin": "Marja de sus",
    "Bottom margin": "Marja de jos",
    "Left margin": "Marginea stângă",
    "Right margin": "Marginea din dreapta",
    "Normal": "Normal",
    "Heading": "Titlu",
    "Heading 1": "Titlul 1",
    "Heading 2": "Titlul 2",
    "Heading 3": "Titlul 3",
    "Heading 4": "Titlul 4",
    "Heading 5": "Titlul 5",
    "Heading 6": "Titlul 6",
    "Heading 7": "Titlu 7",
    "Heading 8": "Titlu 8",
    "Heading 9": "Titlu 9",
    "Heading 2 Char": "Caracter Titlu 2",
    "Heading 3 Char": "Caracter Titlu 3",
    "Heading 4 Char": "Caracter Titlu 4",
    "Heading 5 Char": "Caracter Titlu 5",
    "Heading 6 Char": "Caracter Titlu 6",
    "Heading 7 Char": "Caracter Titlu 7",
    "Heading 8 Char": "Caracter Titlu 8",
    "Heading 9 Char": "Caracter Titlu 9",
    "Header Char": "Caracter Antet",
    "Footer Char": "Caracter Subsol",
    "Default Paragraph Font": "Font Implicit Paragraf",
    "ZoomLevelTooltip": "Nivel de panoramare. Faceți clic sau atingeți pentru a deschide opțiunile de panoramare.",
    "None": "Fără",
    "Borders": "Chenare",
    "ShowHiddenMarks Tooltip": "Afișați caracterele ascunse, cum ar fi spații, tabulație, semne de paragraf și pauze. (Ctrl + *)",
    "Columns": "Coloane",
    "Column Break": "Întrerupere de coloană",
    "Link to Previous": "Leagă de secțiunea anterioară",
    "Link to PreviousTooltip": "Conectați această secțiune la antetul sau subsolul secțiunii anterioare",
    "Alternate Text": "Text alternativ",
    "The address of this site is not valid. Check the address and try again.": "Adresa acestui site nu este valabilă. ",
    "OK": "OK",
    "Information": "Informație",
    "Page Breaks": "Întreruperi de pagină",
    "Section Breaks": "Întreruperi de secțiune",
    "Column": "Coloană",
    "Next Page": "Pagina următoare",
    "Continuous": "Continuu",
    "Header & Footer": "Antet și subsol",
    "Comment": "Comentariu",
    "Links": "Link -uri",
    "Illustrations": "Ilustrații",
    "Tables": "Tabele",
    "Home": "Pornire",
    "Cut": "Decupare",
    "Copy": "Copiere",
    "Replace": "Înlocuire",
    "Clipboard": "Clipboard",
    "Views": "Vizualizări",
    "Zoom": "Zoom",
    "Zoom In": "Mărire",
    "Zoom Out": "Micșorare",
    "One Page": "O pagină",
    "Page Width": "Lățimea paginii",
    "Show": "Afișare",
    "Ruler": "Riglă",
    "Show Bookmarks": "Afișează marcaje",
    "View": "Vizualizare",
    "Page Numbers": "Numere de pagini",
    "Insert automatic page numbering": "Introduceți numerotarea automată a paginilor",
    "Previous Section": "Secțiunea anterioară",
    "Next Section": "Următoarea secțiune",
    "Navigation": "Navigare",
    "Close": "Închidere",
    "Close Header and Footer": "Închideți antetul și subsolul",
    "Close header and footer view": "Închideți antetul și vizualizarea subsolului",
    "Link to the previous sections header and footer": "Link către antetul și subsolul secțiunilor anterioare",
    "Picture Format": "Format de imagine",
    "Picture Tools": "Instrumente de imagine",
    "Adjust image width": "Reglați lățimea imaginii",
    "Adjust image height": "Reglați înălțimea imaginii",
    "Maintain aspect ratio when resizing": "Mențineți raportul de aspect la redimensionare",
    "Add descriptive text for screen readers": "Adăugați text descriptiv pentru cititorii de ecran",
    "Enter alternate text": "Introduceți text alternativ",
    "Adjust image width and height": "Reglați lățimea și înălțimea imaginii",
    "Pages": "Pagini",
    "References": "Referințe",
    "Margins": "Marje",
    "Narrow": "Îngust",
    "Moderate": "Moderat",
    "Wide": "Lat",
    "Custom Margins": "Marje personalizate",
    "Orientation": "Orientare",
    "Portrait": "Portret",
    "Landscape": "Vedere",
    "Size": "Dimensiune",
    "Letter": "Scrisoare",
    "Legal": "Legal",
    "Executive": "Executiv",
    "A4": "A4",
    "A5": "A5",
    "Custom Size": "Dimensiune personalizată",
    "One": "Unul",
    "Two": "Două",
    "Three": "Trei",
    "More Columns": "Mai multe coloane",
    "Breaks": "Pauze",
    "Left Indent": "Indentarea stângă",
    "Right Indent": "Indentare dreaptă",
    "Before Spacing": "Înainte de distanțare",
    "After Spacing": "După distanțare",
    "Layout": "Aspect",
    "Footnotes": "Note de subsol",
    "Update Table": "Actualizați tabelul",
    "PageSetup": "Configurarea paginii",
    "Indent": "Indentare",
    "Spacing": "Distanțare",
    "CustomPageSize": "Dimensiune personalizată ...",
    "MoreColumns": "Mai multe coloane ...",
    "PageBreak": "Pauză de pagină",
    "ColumnBreak": "Pauză de coloană",
    "Before": "Înainte",
    "After": "După",
    "LeftIndent": "Stânga",
    "LeftIndentTooltip": "Setați liniuța din stânga pentru paragraf",
    "RightIndent": "Corect",
    "RightIndentTooltip": "Setați liniuța potrivită pentru paragraf",
    "SpacingBefore": "Înainte",
    "SpacingBeforeTooltip": "Setați distanța înainte de paragraf",
    "SpacingAfter": "După",
    "SpacingAfterTooltip": "Setați distanța după paragraf",
    "ParagraphDialogTooltip": "Deschideți dialogul de paragraf",
    "Bookmarks": "Marcaje",
    "Insert Bookmark": "Introduceți marcajul",
    "All Bookmarks": "Toate marcajele",
    "Create or manage bookmarks in your document": "Creați sau gestionați marcaje în documentul dvs.",
    "View all bookmarks in the document": "Vizualizați toate marcajele din document",
    "Toggle visibility of bookmark markers in the document": "Comutați vizibilitatea markerilor de marcaj în document",
    "New Comment": "Comentariu nou",
    "Add a comment about the current selection": "Adăugați un comentariu despre selecția curentă",
    "Insert a table of contents": "Inserează un cuprins",
    "Insert a page break at the current position": "Introduceți o pauză de pagină la poziția curentă",
    "Review": "Revizuire",
    "Previous": "Anterior",
    "Next": "Următorul",
    "Delete": "Ștergere",
    "Delete All": "Ștergere totală",
    "Show Comments": "Arată comentarii",
    "Tracking": "Urmărire",
    "Accept All": "Acceptare totală",
    "Reject All": "Respingere totală",
    "Protect": "Protejare",
    "Protect Document": "Protejare document",
    "Read Only": "Doar în citire",
    "Encrypt with Password": "Criptați cu parolă",
    "Restrict Access": "Restricționează accesul",
    "Mark as Final": "Marchează drept versiune finală",
    "Insert a comment at the cursor position": "Introduceți un comentariu în poziția cursorului",
    "Go to the previous comment": "Accesați comentariul anterior",
    "Go to the next comment": "Mergeți la următorul comentariu",
    "Delete comments": "Ștergeți comentariile",
    "Show or hide comments": "Arată sau ascunde comentarii",
    "Track changes while editing the document": "Urmăriți modificările în timp ce editați documentul",
    "Accept all changes in the document": "Acceptați toate modificările din document",
    "Reject all changes in the document": "Respingeți toate modificările din document",
    "Control what types of changes can be made to the document": "Controlați ce tipuri de modificări pot fi făcute în document",
    "Make the document read-only": "Faceți documentul doar în citire",
    "Restrict how users can edit the document": "Restricționează modul în care utilizatorii pot edita documentul",
    "Print Layout": "Aspect imprimat",
    "Web Layout": "Aspect web",
    "Toggle document to read only mode": "Comută documentul în modul doar-citire",
    "Navigation Pane": "Panoul de navigare",
    "Show or hide the navigation pane": "Afișați sau ascundeți panoul de navigare",
    "Grow Font Size": "Mărește dimensiunea fontului (Ctrl+Shift+>)",
    "Shrink Font Size": "Micșorează dimensiunea fontului (Ctrl+Shift+<)",
    "Shading": "Umbrire",
    "Select": "Selectare",
    "Row": "Rând",
    "Rows & Columns": "Rânduri și coloane",
    "Table Layout": "Aspect tabel",
    "Row Above": "Rând deasupra",
    "Row Below": "Rând dedesubt",
    "Column Left": "Coloana stânga",
    "Column Right": "Coloană dreapta",
    "Cut Tooltip": "Decupare (Ctrl+X)",
    "Copy Tooltip": "Copiere (Ctrl+C)",
    "100%": "100%",
    "Zoom your document to 100%": "Măriți documentul la 100%",
    "Office2003Default": "Office 2003 implicit",
    "CustomMargins": "Marjele personalizate ...",
    "MarginsTooltip": "Alegeți setările marjei paginii pentru document",
    "Indent Left": "Indentare stânga",
    "Indent Right": "Indentare dreapta",
    "Spacing Before": "Distanțare înainte",
    "Spacing After": "Distanțare după",
    "Set the distance between paragraph and left margin": "Setați distanța dintre paragraf și marja stângă",
    "Set the distance between paragraph and right margin": "Setați distanța dintre paragraf și marja dreaptă",
    "Set the spacing before the paragraph": "Setați distanța înainte de paragraf",
    "Set the spacing after the paragraph": "Setați distanța după paragraf",
    "Table Design": "Design tabel",
    "Properties": "Proprietăți",
    "Show the Table Properties dialog": "Afișați dialogul proprietăților tabelului",
    "Alt Text": "Text alternativ",
    "Alternative Text": "Text alternativ",
    "Enter alt text for this image": "Introduceți textul alternativ pentru această imagine",
    "Apply": "Aplicare",
    "Accessibility": "Accesibilitate",
    "Add alternative text to the image for accessibility": "Adăugați text alternativ la imagine pentru accesibilitate",
    "File": "Fişier",
    "Export": "Export",
    "Print": "Imprimare",
    "Syncfusion Document Text (*.sfdt)": "Syncfusion Document Text (*.sfdt)",
    "Word Document (*.docx)": "Word Document (*.docx)",
    "Word Template (*.dotx)": "Șablon Word (*.dotx)",
    "Plain Text (*.txt)": "Text simplu (*.txt)",
    "Unsupported format": "Format neacceptat",
    "BackstageView": "Vizualizare în culise",
    "BackstageHeader": "Gestionarea fișierelor",
    "BackstageClose": "Închidere",
    "Developer": "Dezvoltator",
    "Insert form fields": "Inserare câmpuri de formular",
    "Controls": "Controale",
    "Insert content controls": "Inserare controale de conținut",
    "Mapping": "Mapare",
    "Restrict editing": "Restricționare editare",
    "More Paragraph Options": "Mai multe opțiuni de paragraf",
    "More Font Options": "Mai multe opțiuni de font",
    "Show/Hide Marks": "Afișare/ascundere marcaje",
    "All Borders": "Toate chenarele",
    "Outside Borders": "Chenare exterioare",
    "Inside Borders": "Chenare interioare",
    "Top Border": "Chenar sus",
    "Bottom Border": "Chenar jos",
    "Left Border": "Chenar stânga",
    "Right Border": "Chenar dreapta",
    "Inside Horizontal Border": "Chenar interior orizontal",
    "Inside Vertical Border": "Chenar interior vertical",
    "Table Borders": "Chenare tabel",
    "Border Color": "Culoare chenar",
    "Border Width": "Lățime chenar",
    "px": "px",
    "SizeTooltip": "Alegeți o dimensiune a hârtiei pentru document",
    "OrientationTooltip": "Alegeți orientarea paginii",
    "ColumnsTooltip": "Alegeți coloanele pentru document",
    "Insert rows and columns": "Introduceți rânduri și coloane",
    "Select the table": "Selectați tabelul",
    "Delete the table": "Ștergeți tabelul",
    "Cell Properties": "Proprietăți celulă",
    "Show or hide the rulers": "Afișează sau ascunde riglele",
    "Show or hide bookmarks": "Afișează sau ascunde marcajele",
    "Show Bookmark Markers": "Afișează marcatorii de marcaj",
    "Show or hide bookmark markers": "Afișați sau ascundeți marcaje de marcaj"
  },
  "documenteditor": {
    "Table": "Tabel",
    "Row": "Rând",
    "Cell": "Celulă",
    "Ok": "OK",
    "Apply": "Aplică",
    "Cancel": "Anulare",
    "Size": "Dimensiune",
    "Preferred Width": "Lățimea preferată",
    "Points": "Puncte",
    "Percent": "Procent",
    "Measure in": "Unitate de măsură",
    "Alignment": "Aliniere",
    "Left": "Stânga",
    "Center": "Centru",
    "Right": "Dreapta",
    "Decimal": "Zecimal",
    "Bar": "Bară",
    "Leader": "Caracter de umplere",
    "Tab": "Tabulator",
    "BookMarkList": "Afișează lista de marcaje.",
    "TabMarkList": "Afișează tabulatorii paragrafului.",
    "Tab stop position": "Poziție tabulator",
    "Default tab stops": "Tabulatori impliciți",
    "Tab stops to be cleared": "Tabulatori de șters",
    "Tabs": "Tabulatori",
    "Set": "Setează",
    "Clear": "Șterge",
    "Clear All": "Șterge tot",
    "Justify": "Stânga-dreapta",
    "Indent from left": "Indentare de la stânga",
    "Borders and Shading": "Chenare și umbrire",
    "Options": "Opțiuni",
    "Specify height": "Precizați înălțimea",
    "At least": "Cel puțin",
    "Exactly": "Exact",
    "Row height is": "Înălțimea rândului este",
    "Allow row to break across pages": "Permiteți rândului să împartă paginile",
    "Repeat as header row at the top of each page": "Repetați ca rândul antet în partea de sus a fiecărei pagini",
    "Vertical alignment": "Aliniere verticală",
    "Top": "Sus",
    "Bottom": "Jos",
    "Default cell margins": "Margini implicite celulă",
    "Default cell spacing": "Spațiere implicită între celule",
    "Allow spacing between cells": "Permiteți distanțarea între celule",
    "Cell margins": "Margini celulă",
    "Same as the whole table": "La fel ca întregul tabel",
    "Borders": "Chenare",
    "None": "Fără",
    "Style": "Stil",
    "Width": "Lățime",
    "Height": "Înălțime",
    "Letter": "Letter",
    "Tabloid": "Tabloid",
    "Legal": "Legal",
    "Statement": "Statement",
    "Executive": "Executiv",
    "A3": "A3",
    "A4": "A4",
    "A5": "A5",
    "B4": "B4",
    "B5": "B5",
    "Custom Size": "Dimensiune particularizată",
    "Different odd and even": "Pagini impare și pare diferite",
    "Different first page": "Prima pagină diferită",
    "From edge": "De la margine",
    "Header": "Antet",
    "Footer": "Subsol",
    "First Page Header": "Antet prima pagină",
    "First Page Footer": "Subsol prima pagină",
    "Even Page Header": "Antet pagină pară",
    "Even Page Footer": "Subsol pagină pară",
    "Odd Page Header": "Antet pagină impară",
    "Odd Page Footer": "Subsol pagină impară",
    "Same as Previous": "La fel ca și precedentul",
    "Section": "Secțiune",
    "Margin": "Margini",
    "Paper": "Hârtie",
    "Layout": "Aspect",
    "Orientation": "Orientare",
    "Landscape": "Vedere",
    "Portrait": "Portret",
    "Show page numbers": "Afișează numerele paginii",
    "Right align page numbers": "Aliniază la dreapta numerele de pagină",
    "Nothing": "Nimic",
    "Tab leader": "Caracter de umplere",
    "Show levels": "Afișați nivelurile",
    "Use hyperlinks instead of page numbers": "Folosiți hyperlink-uri în loc de numere de pagină",
    "Build table of contents from": "Construiți un conținut din",
    "Styles": "stiluri",
    "Available styles": "Stiluri disponibile",
    "TOC level": "Nivelul TOC",
    "Heading": "Titlu",
    "Heading 1": "Titlul 1",
    "Heading 2": "Titlul 2",
    "Heading 3": "Titlul 3",
    "Heading 4": "Titlul 4",
    "Heading 5": "Titlul 5",
    "Heading 6": "Titlul 6",
    "Heading 7": "Titlu 7",
    "Heading 8": "Titlu 8",
    "Heading 9": "Titlu 9",
    "Heading 2 Char": "Caracter Titlu 2",
    "Heading 3 Char": "Caracter Titlu 3",
    "Heading 4 Char": "Caracter Titlu 4",
    "Heading 5 Char": "Caracter Titlu 5",
    "Heading 6 Char": "Caracter Titlu 6",
    "Heading 7 Char": "Caracter Titlu 7",
    "Heading 8 Char": "Caracter Titlu 8",
    "Heading 9 Char": "Caracter Titlu 9",
    "Header Char": "Caracter Antet",
    "Footer Char": "Caracter Subsol",
    "Default Paragraph Font": "Font Implicit Paragraf",
    "List Paragraph": "Paragraful listei",
    "Normal": "Normal",
    "Outline levels": "Niveluri contur",
    "Table entry fields": "Câmpuri de intrare în tabel",
    "Modify": "Modifică",
    "Color": "Culoare",
    "Setting": "Setare",
    "Box": "Casetă",
    "All": "Toate",
    "Custom": "Personalizat",
    "Preview": "Previzualizare",
    "Shading": "Umbrire",
    "Fill": "Umplere",
    "Apply To": "Aplica pentru",
    "Border Style information": "Stilul de chenar selectat nu este acceptat pentru afișare în acest editor, așa că va fi afișat ca niște chenaruri solide. Cu toate acestea, stilul de chenar selectat va fi menținut în document și va fi redat cu acuratețe atunci când documentul este deschis în alte Vizualizare/Editoare Word.",
    "Table Properties": "Proprietățile tabelului",
    "Cell Options": "Opțiuni celulă",
    "Table Options": "Opțiuni de tabel",
    "Insert Table": "Inserează tabel",
    "Number of columns": "Numar de coloane",
    "Number of rows": "Număr de rânduri",
    "Text to display": "Text de afișat",
    "ScreenTip text": "Text cu sfaturi pentru ecran",
    "Address": "Adresă",
    "Insert Hyperlink": "Inserează hyperlink",
    "Edit Hyperlink": "Editează hyperlinkul",
    "Insert": "Inserare",
    "General": "General",
    "The number must be between": "Numărul trebuie să fie între 1 și 9",
    "The Invalid number": "Acesta nu este un număr valid",
    "Indentation": "Indentare",
    "Before text": "Înainte de text",
    "Special": "Special",
    "First line": "Prima linie",
    "Hanging": "Agăţat",
    "After text": "După text",
    "By": "De",
    "Before": "Inainte de",
    "Line Spacing": "Spațiere între rânduri",
    "After": "După",
    "At": "La",
    "Multiple": "Multiplu",
    "Spacing": "Spațiere",
    "Define new Multilevel list": "Definiți o nouă listă pe mai multe niveluri",
    "List level": "Nivel de listă",
    "Choose level to modify": "Alegeți nivelul de modificat",
    "Level": "Nivel",
    "Number format": "Formatul numărului",
    "Number style for this level": "Stilul numerelor pentru acest nivel",
    "Enter formatting for number": "Introduceți formatarea pentru numărul",
    "Start at": "Incepe la",
    "Restart list after": "Reporniți lista după",
    "Position": "Poziție",
    "Text indent at": "Indentare text la",
    "Aligned at": "Aliniat la",
    "Follow number with": "Urmăriți numărul cu",
    "Tab character": "Caracter tabulator",
    "Space": "Spaţiu",
    "Arabic": "Arabic",
    "UpRoman": "UpRoman",
    "LowRoman": "LowRoman",
    "UpLetter": "UpLetter",
    "LowLetter": "LowLetter",
    "Number": "Număr",
    "Leading zero": "Zero la început",
    "Bullet": "Marcator",
    "Ordinal": "Ordinal",
    "Ordinal Text": "Text ordinal",
    "For East": "Pentru est",
    "No Restart": "Fără restart",
    "Font": "Font",
    "Font style": "Stil font",
    "Underline style": "Stil subliniere",
    "Font color": "Culoarea fontului",
    "Effects": "Efecte",
    "Strikethrough": "Barat",
    "Superscript": "Exponent",
    "Subscript": "Indice",
    "Double strikethrough": "Tăiere dublă",
    "Regular": "Obișnuit",
    "Bold": "Bold",
    "Italic": "Cursiv",
    "Cut": "Decupare",
    "Copy": "Copiere",
    "Paste": "Lipește",
    "Hyperlink": "Hyperlink",
    "Open Hyperlink": "Deschide hyperlinkul",
    "Copy Hyperlink": "Copiază hyperlinkul",
    "Remove Hyperlink": "Elimină hyperlinkul",
    "Paragraph": "Paragraf",
    "Linked Style": "Legat (paragraf și caracter)",
    "Character": "Caracter",
    "Merge Cells": "Îmbină celulele",
    "Insert Above": "Inserează deasupra",
    "Insert Below": "Inserează dedesubt",
    "Insert Left": "Inserează la stânga",
    "Insert Right": "Inserează la dreapta",
    "Delete": "Șterge",
    "Delete Table": "Șterge tabelul",
    "Delete Row": "Șterge rândul",
    "Delete Column": "Șterge coloana",
    "File Name": "Nume de fișier",
    "Format Type": "Tip de format",
    "Save": "Salvează",
    "Navigation": "Navigare",
    "Results": "Rezultate",
    "Replace": "Înlocuire",
    "Replace All": "Înlocuiește tot",
    "We replaced all": "Am înlocuit toate",
    "Find": "Găsire",
    "No matches": "Nicio potrivire",
    "All Done": "Totul este gata",
    "Result": "Rezultat",
    "of": "de",
    "instances": "instanțe",
    "with": "cu",
    "Click to follow link": "Faceți clic pentru a urma linkul",
    "Continue Numbering": "Continuă numerotarea",
    "Bookmark name": "Numele marcajului",
    "Close": "Închidere",
    "Restart At": "Reîncepe la",
    "Properties": "Proprietăți",
    "Name": "Nume",
    "Style type": "Tip de stil",
    "Style based on": "Stil bazat pe",
    "Style for following paragraph": "Stil pentru următorul alineat",
    "Formatting": "Formatarea",
    "Numbering and Bullets": "Numerotare și marcatori",
    "Numbering": "Numerotare",
    "Update Field": "Actualizează câmpul",
    "Edit Field": "Editează câmpul",
    "Bookmark": "Marcaj",
    "Page Setup": "Configurare pagină",
    "No bookmarks found": "Nu au fost găsite marcaje",
    "Number format tooltip information": "Format de număr la un singur nivel: </br> [PREFIX]% [NIVEL]] [SUFFIX] </br> De exemplu, „Capitolul% 1.” va afișa numerotare ca </br> Capitolul 1. Element </br> Capitolul 2. Elemente </br> ... </br> Capitolul N. Elemente </br> </br> Format de număr pe mai multe niveluri: </br> [ PREFIX]% [LEVELNUMBER] [SUFFIX] + [PREFIX]% [LEVELNUMBER] [SUFFIX] </br> De exemplu, „% 1.% 2.” va afișa numerotare ca </br> 1.1. Postul </br> 1.2. Articol </br> ... </br> 1.N. Articol",
    "Format": "Format",
    "Create New Style": "Creați stil nou",
    "Modify Style": "Modificați stilul",
    "New": "Nou",
    "Bullets": "Marcatori",
    "Use bookmarks": "Folosiți marcaje",
    "Table of Contents": "Cuprins",
    "AutoFit": "Potrivire automată",
    "AutoFit to Contents": "Potrivire automată la conținut",
    "AutoFit to Window": "Potrivire automată la fereastră",
    "Fixed Column Width": "Lățimea fixă ​​a coloanei",
    "Reset": "Resetați",
    "Match case": "Potrivire litere mari și mici",
    "Whole words": "Cuvinte întregi",
    "Add": "Adaugă",
    "Go To": "Mergi la",
    "Search for": "Caută",
    "Replace with": "Înlocui cu",
    "TOC 1": "TOC 1",
    "TOC 2": "TOC 2",
    "TOC 3": "TOC 3",
    "TOC 4": "TOC 4",
    "TOC 5": "TOC 5",
    "TOC 6": "TOC 6",
    "TOC 7": "TOC 7",
    "TOC 8": "TOC 8",
    "TOC 9": "TOC 9",
    "Right-to-left": "De la dreapta la stanga",
    "Left-to-right": "De la stânga la dreapta",
    "Direction": "Direcţie",
    "Table direction": "Direcția tabelului",
    "Indent from right": "Indentare de la dreapta",
    "Contextual Spacing": "Nu adăugați spațiu între alineatele din aceleași stiluri",
    "Password Mismatch": "Parola nu se potrivește",
    "Restrict Editing": "Restricționare editare",
    "Formatting restrictions": "Restricții de formatare",
    "Allow formatting": "Permite formatarea",
    "Editing restrictions": "Restricții de editare",
    "Read only": "Doar citire",
    "Exceptions Optional": "Excepții (opțional)",
    "Select Part Of Document And User": "Selectați părți ale documentului și alegeți utilizatorii cărora li se permite să le editeze liber.",
    "Everyone": "Toata lumea",
    "More users": "Mai mulți utilizatori",
    "Add Users": "Adăugați utilizatori",
    "Enforcing Protection": "Da, începeți să impuneți protecția",
    "Start Enforcing Protection": "Începeți să impuneți protecția",
    "Enter User": "Introduceți utilizatorul",
    "Users": "Utilizatori",
    "Enter new password": "Introduceți o parolă nouă",
    "Reenter new password to confirm": "Reintroduceți noua parolă pentru confirmare",
    "Your permissions": "Permisiunile dvs.",
    "Protected Document": "Acest document este protejat împotriva editării neintenționate. Puteți edita în această regiune.",
    "FormFieldsOnly": "Puteți completa formulare doar în această regiune.",
    "CommentsOnly": "Puteți introduce doar comentarii în această regiune.",
    "ReadOnlyProtection": "Puteți edita în această regiune.",
    "Stop Protection": "Opriți protecția",
    "Password": "Parola",
    "Spelling Editor": "Editor de ortografie",
    "Spelling": "Ortografie",
    "Spell Check": "Verificare ortografică",
    "Underline errors": "Subliniază erorile",
    "Ignore": "Ignoră",
    "Ignore All": "Ignoră tot",
    "Add to Dictionary": "Adaugă în dicționar",
    "Change": "Modifică",
    "Change All": "Modifică tot",
    "Suggestions": "Sugestii",
    "The password is incorrect": "Parola este incorecta",
    "Error in establishing connection with web server": "Eroare la stabilirea conexiunii cu serverul web",
    "Highlight the regions I can edit": "Evidențiați regiunile pe care le pot edita",
    "Show All Regions I Can Edit": "Afișează toate regiunile pe care le pot edita",
    "Find Next Region I Can Edit": "Găsiți regiunea următoare pe care o pot edita",
    "Keep source formatting": "Păstrează formatarea sursei",
    "Match destination formatting": "Potrivește formatarea destinației",
    "Text only": "Doar text",
    "Comments": "Comentarii",
    "Type your comment": "Tastați comentariul",
    "Post": "Publică",
    "Reply": "Răspunde",
    "New Comment": "Comentariu nou",
    "Edit": "Editează",
    "Resolve": "Rezolvă",
    "Reopen": "Redeschide",
    "No comments in this document": "Nu există comentarii în acest document",
    "more": "Mai Mult",
    "Type your comment here": "Introdu comentariul tău aici",
    "Next Comment": "Următorul comentariu",
    "Previous Comment": "Comentariu anterior",
    "Unsaved comments": "Comentarii nesalvate",
    "Discard Comment body": "Aveți comentarii care nu au fost încă publicate. Dacă părăsiți această pagină, vor fi eliminate.",
    "Discard": "Aruncă",
    "Discard comments": "Elimină comentariile",
    "Keep editing": "Continuă editarea",
    "No Headings": "Nu a fost găsit un titlu!",
    "Add Headings": "Acest document nu are titluri. Vă rugăm să adăugați rubrici și să încercați din nou.",
    "More Options": "Mai multe opțiuni",
    "Click to see this comment": "Faceți clic pentru a vedea acest comentariu",
    "Drop Down Form Field": "Câmp de formular tip listă derulantă",
    "Drop-down items": "Elemente drop-down",
    "Items in drop-down list": "Elemente din lista derulantă",
    "ADD": "ADAUGĂ",
    "REMOVE": "ELIMINĂ",
    "Field settings": "Setări câmp",
    "Tooltip": "Tooltip",
    "Drop-down enabled": "Listă derulantă activată",
    "Check Box Form Field": "Câmp de formular casetă de selectare",
    "Check box size": "Dimensiune casetă",
    "Auto": "Auto",
    "Default value": "Valoare implicită",
    "Not checked": "Nebifat",
    "Checked": "Bifat",
    "Check box enabled": "Caseta de selectare este activată",
    "Text Form Field": "Câmp Formular Text",
    "Type": "Tip",
    "Default text": "Text implicit",
    "Maximum length": "Lungime maxima",
    "Text format": "Formatul textului",
    "Fill-in enabled": "Completare activată",
    "Default number": "Număr implicit",
    "Default date": "Data implicită",
    "Date format": "Formatul datei",
    "Merge Track": "Această acțiune nu va fi marcată ca modificare. Doriți să continuați?",
    "UnTrack": "Nu poate fi urmărit",
    "Accept": "Acceptă",
    "Reject": "Respinge",
    "Previous Changes": "Modificări anterioare",
    "Next Changes": "Următoarele modificări",
    "Inserted": "Inserat",
    "Deleted": "Șters",
    "Move From": "Mutat din",
    "Move To": "Mutat în",
    "Changes": "Schimbări",
    "Accept all": "Acceptă toate",
    "Reject all": "Respinge toate",
    "No changes": "Nici o schimbare",
    "Accept Changes": "Acceptați modificările",
    "Reject Changes": "Respingeți modificările",
    "User": "Utilizator",
    "View": "Vizualizare",
    "Insertion": "Inserare",
    "Deletion": "Ștergere",
    "All caps": "Majuscule",
    "This region is locked by": "Această regiune este blocată de",
    "Lock": "Lacăt",
    "Unlock": "Deblocați",
    "Already locked": "Selectat sau o parte a regiunii este deja blocată de un alt utilizator",
    "1, 2, 3, ...": "1, 2, 3, ...",
    "a, b, c, ...": "a, b, c, ...",
    "A, B, C, ...": "A, B, C, ...",
    "I, II, III, ...": "I, II, III, ...",
    "i, ii, iii, ...": "i, ii, iii, ...",
    "Text Form": "Formular text",
    "Check Box": "Caseta de bifat",
    "DropDown": "Listă derulantă",
    "Form Fields": "Câmpuri formular",
    "Fillin enabled": "Completarea este activată",
    "Multiple Comment": "Vă rugăm să postați comentariul dvs.",
    "InsertFootnote": "Inserați o notă de subsol",
    "InsertEndnote": "Inserează notă de final",
    "Footnote": "Notă de subsol",
    "Endnote": "Notă finală",
    "Notes Options": "Opțiuni note",
    "Click to View/Edit Footnote": "Faceți clic pentru a vizualiza / edita nota de subsol",
    "Click to View/Edit Endnote": "Faceți clic pentru a vizualiza / edita nota finală",
    "InsertAsRows": "Inserați ca rânduri noi",
    "InsertAsColumns": "Inserați ca coloane noi",
    "OverwriteCells": "Suprascrieți celulele",
    "NestTable": "Tabel imbricat",
    "No suggestions": "Fără sugestii",
    "More Suggestion": "Mai multe sugestii",
    "Ignore Once": "Ignoră o dată",
    "Keep With Next": "Păstrează cu paragraful următor",
    "Keep Lines Together": "Păstrează rândurile împreună",
    "WidowControl": "Control rânduri văduve/orfane",
    "Indents and Spacing": "Indentări și spațiere",
    "Line and Page Breaks": "Linie și întreruperi de pagină",
    "Pagination": "Paginare",
    "Single": "Simplu",
    "DashSmallGap": "DashSmallGap",
    "DashDot": "DashDot",
    "Double": "Dublu",
    "ThinThickSmallGap": "ThinThickSmallGap",
    "ThickThinSmallGap": "ThickThinSmallGap",
    "ThickThinMediumGap": "ThickThinMediumGap",
    "ThickThinLargeGap": "ThickThinLargeGap",
    "SingleWavy": "SingleWavy",
    "DoubleWavy": "DoubleWavy",
    "Inset": "Adâncit",
    "DashLargeGap": "DashLargeGap",
    "Dot": "Punct",
    "DashDotDot": "DashDotDot",
    "Triple": "Triplu",
    "ThinThickThinSmallGap": "ThinThickThinSmallGap",
    "ThinThickThinMediumGap": "ThinThickThinMediumGap",
    "ThinThickThinLargeGap": "ThinThickThinLargeGap",
    "DashDotStroked": "DashDotStroked",
    "Engrave3D": "Gravare 3D",
    "Thick": "Gros",
    "Outset": "Reliefat",
    "Emboss3D": "Emboss3D",
    "ThinThickLargeGap": "ThinThickLargeGap",
    "ThinThickMediumGap": "ThinThickMediumGap",
    "Number of rows must be between": "Numărul de rânduri trebuie să fie între",
    "Number of columns must be between": "Numărul de coloane trebuie să fie între",
    "and": "și",
    "Unlimited": "Nelimitat",
    "Regular text": "Text obișnuit",
    "Date": "Data",
    "Uppercase": "Majuscule",
    "Lowercase": "Minuscule",
    "FirstCapital": "Prima literă mare",
    "SentenceCase": "Tip propoziție",
    "CapitalizeEachWord": "Fiecare Cuvânt Cu Majuscule",
    "ToggleCase": "Comutare MAJUSCULE/minuscule",
    "TitleCase": "Stil titlu",
    "Filling in forms": "Completarea formularelor",
    "px": "px",
    "Tracked changes": "Modificări urmărite",
    "TrackChangesOnly": "Puteți edita în această regiune, dar toate modificările vor fi urmărite.",
    "RemovedIgnore": "Doriți să eliminați excepțiile ignorate?",
    "RemovedIgnoreExceptions": "Dacă faceți această modificare în protecția documentelor, Word va ignora toate excepțiile din acest document.",
    "Information": "Informație",
    "Yes": "Da",
    "No": "Nu",
    "Page Break": "Întrerupere de pagină",
    "Column Break": "Întrerupere de coloană",
    "Section Break Next Page": "Întrerupere de secțiune (Pagina următoare)",
    "Section Break Continuous": "Întrerupere de secțiune (continuă)",
    "Unsupported format": "Formatul de fișier pe care l-ați selectat nu este acceptat. Vă rugăm să alegeți un format valid.",
    "One": "Una",
    "Two": "Două",
    "Three": "Trei",
    "Presets": "Presetări",
    "Columns": "Coloane",
    "Split your text into two or more columns": "Împărțiți textul în două sau mai multe coloane",
    "Line between column": "Linie între coloană",
    "Width and Spacing": "Lățime și distanță",
    "Equal column width": "Lățimea coloanei este egală",
    "Column": "Coloană",
    "Paste Content Dialog": "Din cauza politicii de securitate a browserului, lipirea din clipboard-ul sistemului este restricționată. ",
    "Paste Content CheckBox": "Nu mai apărea.",
    "The top/bottom margins are too large for the page height in some sections.": "Marginile de sus/de jos sunt prea mari pentru înălțimea paginii în unele secțiuni.",
    "Column width cannot be less than 36 pt.": "Lățimea coloanei nu poate fi mai mică de 36 de puncte.",
    "Left and right margins.": "Setările pe care le-ați ales pentru marginile din stânga și din dreapta, spațierea coloanelor sau indentarea paragrafelor sunt prea mari pentru lățimea paginii din aceleași secțiuni.",
    "The address of this site is 'not valid. Check the address and try again.": "Adresa acestui site nu este valabilă. Verificați adresa și încercați din nou.",
    "Alt Text": "Text alternativ",
    "Title": "Titlu",
    "Description": "Descriere",
    "Left Indent": "Indentare stânga",
    "Right Indent": "Indentare dreapta",
    "Hanging Indent": "Indentare agățată",
    "First Line Indent": "Indentare primul rând",
    "Left Margin": "Margine stânga",
    "Right Margin": "Margine dreapta",
    "Top Margin": "Margine sus",
    "Bottom Margin": "Margine jos",
    "Left Tab": "Tabulator stânga",
    "Right Tab": "Tabulator dreapta",
    "Center Tab": "Tabulator centru",
    "Decimal Tab": "Tabulator zecimal",
    "Bar Tab": "Tabulator bară",
    "Move Table Column": "Mută coloana tabelului",
    "external": "Elimină controlul de conținut",
    "Content Control Properties": "Proprietăți de control al conținutului",
    "Remove content control when contents are edited": "Eliminați controlul conținutului când este editat conținutul",
    "Content control cannot be deleted": "Controlul conținutului nu poate fi șters",
    "Contents cannot be edited": "Conținutul nu poate fi editat",
    "Plain Text properties": "Proprietăți text simplu",
    "Allow carriage returns": "Permiteți marcaje de sfârșit de rând",
    "Drop_Down List properties": "Proprietățile listei Drop_down",
    "Display Text": "Text afișat",
    "Locking": "Blocare",
    "Tag": "Etichetă",
    "Value": "Valoare",
    "PictureContentControl": "PictureContentControl",
    "Upload from computer": "Încărcați de pe computer",
    "Picture": "Imagine",
    "Choose an item": "Alege un element",
    "DropDownLimitWarning": "Puteți avea cel mult 25 de elemente în lista derulantă.",
    "Un-posted comments": "Comentarii nepublicate",
    "Discard Comment": "Comentarii adăugate care nu au fost postate. Dacă continuați, acel comentariu va fi aruncat.",
    "Paste CheckBox Content Dialog": "Nu mai arăta",
    "The address of this site is not valid. Check the address and try again.": "Adresa acestui site nu este valabilă. ",
    "Left and right margins": "Setările pe care le-ați ales pentru marginile din stânga și din dreapta, spațierea coloanelor sau indentarea paragrafelor sunt prea mari pentru lățimea paginii din aceleași secțiuni.",
    "Number of rows must be between 1 and 32767.": "Numărul de rânduri trebuie să fie între 1 și 32767.",
    "Number of columns must be between 1 and 63.": "Numărul de coloane trebuie să fie între 1 și 63.",
    "You may format text only with certain styles": "Puteți formata textul numai cu anumite stiluri.",
    "Ignore all": "Ignora tot"
  },
  "richtexteditor": {
    "alignments": "Aliniere",
    "justifyLeft": "Aliniere la stânga",
    "justifyCenter": "La centru",
    "justifyRight": "Aliniere la dreapta",
    "justifyFull": "Stânga-dreapta",
    "lineHeight": "Spațiere între rânduri",
    "fontName": "Font",
    "fontSize": "Dimensiune font",
    "fontColor": "Culoare font",
    "backgroundColor": "Culoare de evidențiere",
    "importWord": "Import din Word",
    "exportWord": "Export în Word",
    "exportPdf": "Export în PDF",
    "horizontalLine": "Linie orizontală",
    "bold": "Aldin",
    "italic": "Cursiv",
    "underline": "Subliniere",
    "strikethrough": "Barat",
    "clearFormat": "Golire formatare",
    "clearAll": "Golire totală",
    "cut": "Decupare",
    "copy": "Copiere",
    "paste": "Lipire",
    "unorderedList": "Listă cu marcatori",
    "orderedList": "Listă numerotată",
    "indent": "Mărire indent",
    "outdent": "Micșorare indent",
    "undo": "Anulare",
    "redo": "Refacere",
    "superscript": "Exponent",
    "subscript": "Indice",
    "createLink": "Inserare link",
    "openLink": "Deschidere link",
    "editLink": "Editare link",
    "removeLink": "Eliminare link",
    "image": "Inserare imagine",
    "audio": "Inserare audio",
    "video": "Inserare video",
    "replace": "Înlocuire",
    "numberFormatList": "Format listă numerotată",
    "bulletFormatList": "Format listă cu marcatori",
    "audioReplace": "Înlocuire",
    "videoReplace": "Înlocuire",
    "videoAlign": "Aliniere",
    "videoDimension": "Dimensiune",
    "audioRemove": "Eliminare",
    "videoRemove": "Eliminare",
    "audioLayoutOption": "Opțiune aspect",
    "videoLayoutOption": "Opțiune aspect",
    "align": "Aliniere",
    "caption": "Legendă",
    "wrapText": "Încadrare text",
    "remove": "Eliminare",
    "insertLink": "Inserare link",
    "display": "Afișare",
    "altText": "Text alternativ",
    "dimension": "Modificare dimensiune",
    "fullscreen": "Maximizare",
    "maximize": "Maximizare",
    "minimize": "Minimizare",
    "lowerCase": "Minuscule",
    "upperCase": "Majuscule",
    "print": "Imprimare",
    "formats": "Stiluri",
    "sourcecode": "Vizualizare cod",
    "preview": "Examinare",
    "viewside": "Vizualizare alăturată",
    "insertCode": "Inserare cod",
    "blockquote": "Citat",
    "linkText": "Text afișat",
    "linkTooltipLabel": "Titlu",
    "linkWebUrl": "Adresă web",
    "linkTitle": "Introduceți un titlu",
    "linkurl": "https://example.com",
    "linkOpenInNewWindow": "Deschidere link în fereastră nouă",
    "linkHeader": "Inserare link",
    "dialogInsert": "Inserare",
    "dialogCancel": "Revocare",
    "dialogUpdate": "Actualizare",
    "imageHeader": "Inserare imagine",
    "audioHeader": "Inserare audio",
    "videoHeader": "Inserare video",
    "imageLinkHeader": "Puteți furniza și un link de pe web",
    "audioLinkHeader": "Puteți furniza și un link de pe web",
    "videoLinkHeader": "Adresă URL web",
    "embedVideoLinkHeader": "Adresă URL de încorporare media",
    "mdimageLink": "Furnizați o adresă URL pentru imagine",
    "imageUploadMessage": "Fixați imaginea aici sau răsfoiți pentru a încărca",
    "audioUploadMessage": "Fixați un fișier audio aici sau răsfoiți pentru a încărca",
    "videoUploadMessage": "Fixați un fișier video aici sau răsfoiți pentru a încărca",
    "imageDeviceUploadMessage": "Faceți clic aici pentru a încărca",
    "audioDeviceUploadMessage": "Faceți clic aici pentru a încărca",
    "videoDeviceUploadMessage": "Faceți clic aici pentru a încărca",
    "imageAlternateText": "Text alternativ",
    "alternateHeader": "Text alternativ",
    "browse": "Răsfoire",
    "imageUrl": "https://example.com/image.png",
    "audioUrl": "https://example.com/audio.mp3",
    "videoUrl": "https://example.com/video.mp4",
    "webUrl": "Adresă URL web",
    "embedUrl": "Cod de încorporare",
    "imageCaption": "Legendă",
    "imageSizeHeader": "Dimensiune imagine",
    "videoSizeHeader": "Dimensiune video",
    "imageHeight": "Înălțime",
    "imageWidth": "Lățime",
    "videoHeight": "Înălțime",
    "videoWidth": "Lățime",
    "textPlaceholder": "Introduceți text",
    "inserttablebtn": "Inserare tabel",
    "tabledialogHeader": "Inserare tabel",
    "tableWidth": "Lățime",
    "tableHeight": "Înălțime",
    "tableHorizontalAlign": "Aliniere orizontală",
    "tableVerticalAlign": "Aliniere verticală",
    "cellpadding": "Spațiere interioară celulă",
    "cellspacing": "Spațiere între celule",
    "columns": "Număr de coloane",
    "borderWidth": "Lățime",
    "borderColor": "Culoare",
    "borderLabel": "Chenar",
    "tableBackgroundColor": "Culoare de fundal",
    "borderStyle": "Stil",
    "borderWidthTooltip": "Lățime chenar",
    "borderColorTooltip": "Culoare chenar",
    "borderStyleTooltip": "Stil chenar",
    "tablealigntop": "Aliniere sus",
    "tablealignmiddle": "Aliniere la mijloc",
    "tablealignbottom": "Aliniere jos",
    "borderStyleNone": "Fără",
    "borderStyleSolid": "Continuu",
    "borderStyleDashed": "Întrerupt",
    "borderStyleDotted": "Punctat",
    "borderStyleDouble": "Dublu",
    "borderStyleGroove": "Canelat",
    "borderStyleRidge": "Reliefat",
    "borderStyleInset": "Adâncit",
    "borderStyleOutset": "Ieșit în relief",
    "borderStyleHidden": "Ascuns",
    "rows": "Număr de rânduri",
    "tableRows": "Rând",
    "tableColumns": "Coloană",
    "tableCellHorizontalAlign": "Aliniere orizontală celulă tabel",
    "tableCellVerticalAlign": "Aliniere verticală",
    "insertTableRowTitle": "Introduceți un număr întreg de la 1 la 100",
    "insertTableColumnTitle": "Introduceți un număr întreg de la 1 la 50",
    "createTable": "Creare tabel",
    "removeTable": "Eliminare tabel",
    "tableHeader": "Rând antet",
    "tableRemove": "Ștergere tabel",
    "tableCell": "Îmbinare celule",
    "tableCellBackground": "Fundal celulă tabel",
    "tableEditProperties": "Proprietăți editare tabel",
    "tableCellProperties": "Proprietăți celulă tabel",
    "styles": "Stiluri",
    "insertColumnLeft": "Inserare coloană la stânga",
    "insertColumnRight": "Inserare coloană la dreapta",
    "deleteColumn": "Ștergere coloană",
    "insertRowBefore": "Inserare rând deasupra",
    "insertRowAfter": "Inserare rând dedesubt",
    "deleteRow": "Ștergere rând",
    "tableEditHeader": "Editare tabel",
    "tableCellHeader": "Editare celulă",
    "TableHeadingText": "Titlu",
    "TableColText": "Col",
    "imageInsertLinkHeader": "Inserare link",
    "editImageHeader": "Editare imagine",
    "editAudioHeader": "Editare audio",
    "editVideoHeader": "Editare video",
    "alignmentsDropDownLeft": "Aliniere la stânga",
    "alignmentsDropDownCenter": "La centru",
    "alignmentsDropDownRight": "Aliniere la dreapta",
    "alignmentsDropDownJustify": "Stânga-dreapta",
    "imageDisplayDropDownInline": "În linie",
    "imageDisplayDropDownBreak": "Întrerupere",
    "audioLayoutOptionDropDownInline": "În linie",
    "audioLayoutOptionDropDownBreak": "Întrerupere",
    "videoLayoutOptionDropDownInline": "În linie",
    "videoLayoutOptionDropDownBreak": "Întrerupere",
    "tableInsertRowDropDownBefore": "Inserare rând deasupra",
    "tableInsertRowDropDownAfter": "Inserare rând dedesubt",
    "tableInsertRowDropDownDelete": "Ștergere rând",
    "tableInsertColumnDropDownLeft": "Inserare coloană la stânga",
    "tableInsertColumnDropDownRight": "Inserare coloană la dreapta",
    "tableInsertColumnDropDownDelete": "Ștergere coloană",
    "tableVerticalAlignDropDownTop": "Aliniere sus",
    "tableVerticalAlignDropDownMiddle": "Aliniere la mijloc",
    "tableVerticalAlignDropDownBottom": "Aliniere jos",
    "tableStylesDropDownDashedBorder": "Chenare întrerupte",
    "tableStylesDropDownAlternateRows": "Rânduri alternante",
    "pasteFormat": "Format lipire",
    "pasteFormatContent": "Alegeți acțiunea de formatare",
    "plainText": "Text simplu",
    "cleanFormat": "Curățare",
    "keepFormat": "Păstrare",
    "pasteDialogOk": "OK",
    "pasteDialogCancel": "Revocare",
    "fileManager": "Gestionar de fișiere",
    "fileDialogHeader": "Explorator de fișiere",
    "formatsDropDownParagraph": "Paragraf",
    "formatsDropDownCode": "Preformatat",
    "formatsDropDownQuotation": "Citat",
    "formatsDropDownHeading1": "Titlul 1",
    "formatsDropDownHeading2": "Titlul 2",
    "formatsDropDownHeading3": "Titlul 3",
    "formatsDropDownHeading4": "Titlul 4",
    "numberFormatListNumber": "Număr",
    "numberFormatListLowerAlpha": "Litere mici",
    "numberFormatListUpperAlpha": "Litere mari",
    "numberFormatListLowerRoman": "Cifre romane mici",
    "numberFormatListUpperRoman": "Cifre romane mari",
    "numberFormatListLowerGreek": "Litere grecești mici",
    "bulletFormatListDisc": "Disc",
    "bulletFormatListCircle": "Cerc",
    "bulletFormatListSquare": "Pătrat",
    "numberFormatListNone": "Fără",
    "bulletFormatListNone": "Fără",
    "formatPainter": "Descriptor de formate",
    "emojiPicker": "Selector de emoji",
    "embeddedCode": "Cod încorporat",
    "pasteEmbeddedCodeHere": "Lipiți aici codul încorporat",
    "emojiPickerTypeToFind": "Tastați pentru a căuta",
    "emojiPickerNoResultFound": "Nu s-a găsit niciun rezultat",
    "emojiPickerTrySomethingElse": "Încercați altceva",
    "linkAriaLabel": "Deschidere în fereastră nouă",
    "imageLinkAriaLabel": "Deschidere în fereastră nouă",
    "unsupportedImage": "Format de fișier neacceptat",
    "mergecells": "Îmbinare celule",
    "verticalsplit": "Scindare verticală",
    "horizontalsplit": "Scindare orizontală",
    "inlinecode": "Cod în linie",
    "slashMenuItemHeadingOneText": "Titlul 1",
    "slashMenuItemHeadingOneDescription": "Utilizați pentru un titlu de nivel superior sau ca titlu principal.",
    "slashMenuItemHeadingTwoText": "Titlul 2",
    "slashMenuItemHeadingTwoDescription": "Utilizați pentru secțiunile principale.",
    "slashMenuItemHeadingThreeText": "Titlul 3",
    "slashMenuItemHeadingThreeDescription": "Utilizați pentru subsecțiuni și titluri de grup.",
    "slashMenuItemHeadingFourText": "Titlul 4",
    "slashMenuItemHeadingFourDescription": "Utilizați pentru punctele esențiale ale subtemelor.",
    "slashMenuItemParagraphText": "Paragraf",
    "slashMenuItemParagraphDescription": "Scriere cu paragrafe.",
    "slashMenuItemBlockquoteText": "Citat",
    "slashMenuItemBlockquoteDescription": "Creați un citat sau o referință.",
    "slashMenuItemOrderedListText": "Listă numerotată",
    "slashMenuItemOrderedListDescription": "Creați o listă numerotată.",
    "slashMenuItemUnorderedListText": "Listă cu marcatori",
    "slashMenuItemUnorderedListDescription": "Creați o listă cu marcatori.",
    "slashMenuItemCodeText": "Bloc de cod",
    "slashMenuItemCodeDescription": "Creați un bloc de cod preformatat.",
    "slashMenuItemTableText": "Tabel",
    "slashMenuItemTableDescription": "Inserați un tabel.",
    "slashMenuItemLinkText": "Link",
    "slashMenuItemLinkDescription": "Inserați un link.",
    "slashMenuItemImageText": "Imagine",
    "slashMenuItemImageDescription": "Inserați o imagine.",
    "slashMenuItemAudioText": "Audio",
    "slashMenuItemAudioDescription": "Inserați un fișier audio.",
    "slashMenuItemVideoText": "Video",
    "slashMenuItemVideoDescription": "Inserați un fișier video.",
    "slashMenuItemEmojiText": "Selector de emoji",
    "slashMenuItemEmojiDescription": "Utilizați emoji pentru a exprima idei și emoticoane.",
    "aiAssistantName": "Asistent AI",
    "aiAssistantHistoryButton": "Istoric",
    "aiAssistantEmptyPromptHistory": "Nu s-a găsit niciun prompt.",
    "aiAssistantToolbarItemClose": "Închidere",
    "aiAssistantToolbarItemClear": "Golire",
    "aiAssistantToolbarItemCopy": "Copiere",
    "aiAssistantToolbarItemEdit": "Editare",
    "aiAssistantToolbarItemInsert": "Inserare",
    "aiAssistantToolbarItemRegenerate": "Regenerare",
    "aiAssistantMenuEditImprove": "Editare și îmbunătățire",
    "aiAssistantMenuChangeTone": "Modificare ton",
    "aiAssistantMenuChangeStyle": "Modificare stil",
    "aiAssistantMenuTranslate": "Traducere",
    "aiAssistantMenuImproveContent": "Îmbunătățire conținut",
    "aiAssistantMenuShorten": "Scurtare",
    "aiAssistantMenuElaborate": "Detaliere",
    "aiAssistantMenuSimplify": "Simplificare",
    "aiAssistantMenuSummarize": "Rezumare",
    "aiAssistantMenuCheckGrammar": "Verificare gramatică și ortografie",
    "aiAssistantMenuProfessional": "Profesionist",
    "aiAssistantMenuCasual": "Lejer",
    "aiAssistantMenuDirect": "Direct",
    "aiAssistantMenuFriendly": "Prietenos",
    "aiAssistantMenuInspirational": "Inspirațional",
    "aiAssistantMenuPersuasive": "Persuasiv",
    "aiAssistantMenuBusiness": "Afaceri",
    "aiAssistantMenuJournalistic": "Jurnalistic",
    "aiAssistantMenuAcademic": "Academic",
    "aiAssistantMenuGerman": "Germană",
    "aiAssistantMenuSpanish": "Spaniolă",
    "aiAssistantMenuFrench": "Franceză",
    "aiAssistantMenuJapanese": "Japoneză",
    "aiAssistantMenuChinese": "Chineză simplificată",
    "aiAssistantMenuHindi": "Hindi",
    "aiAssistantMenuArabic": "Arabă",
    "codeBlock": "Inserare bloc de cod",
    "aiquery": "Întrebați AI",
    "aicommands": "Comenzi AI",
    "checklist": "Listă de verificare"
  }
};
